// extracted by mini-css-extract-plugin
module.exports = {"container":"Profile_container__1ocX5","col":"Profile_col__1a6gk","profile":"Profile_profile__3_Lo7","illu":"Profile_illu__3QHJC"};